<script>
    import { metaInfo } from "@/core/MetaInfo";
    import TheDetailWrapper from "@auto-admin/components/TheDetailWrapper";
    import { apiUrl } from "@/utils";

    export default {
        name: "OfferDetail",
        props: {
            statusPage: String,
        },
        components: { TheDetailWrapper },
        data() {
            return {
                form: {
                    color: "",
                    issuedAt: "",
                    mileage: 0,
                    photoId: "",
                    price: 0,
                    status: "in_stock",
                    versionId: null,
                },
                file: null,
                versionsList: [],
                isLoading: false,
                modelId: null,
                modelsList: [],
            };
        },
        computed: {
            isNew() {
                return this.statusPage === "new";
            },
            isView() {
                return this.statusPage === "view";
            },
            isEdit() {
                return this.statusPage === "edit";
            },
            title() {
                let filtered = {
                    new: "Добавить Торговое предложение",
                    view: "Торговое предложение",
                    edit: "Редактировать Торговое предложение",
                };
                return filtered[this.statusPage];
            },
        },
        watch: {
            modelId: {
                handler(id) {
                    if (id) {
                        this.getVersions(id);
                    }
                },
            },
        },
        mounted() {
            if (this.isEdit || this.isView) {
                this.loadDataForEdited();
            }
            // this.getVersions();
            this.$store.autoAdminApi.getModels().then(({ data }) => {
                this.modelsList = data.items;
            });
        },
        methods: {
            apiUrl,
            send() {
                if (this.isNew) {
                    this.handlerForCreate();
                }
                if (this.isEdit) {
                    this.handlerForEdit();
                }
                if (this.isView) {
                    this.handlerForView();
                }
            },
            handlerForView() {
                this.$router.push({
                    name: "OfferEdit",
                    params: {
                        slug: this.$route.params.slug,
                    },
                });
            },
            handlerForEdit() {
                this.$store.autoAdminApi
                    .editOffer(this.$route.params.slug, this.form)
                    .then(() => {
                        this.$router.push({
                            name: "Offers",
                        });
                    });
            },
            handlerForCreate() {
                this.$store.autoAdminApi.createOffer(this.form).then(({ data }) => {
                    this.$router.push({
                        name: "Offers",
                    });
                });
            },
            loadDataForEdited() {
                this.$store.autoAdminApi.getOffer(this.$route.params.slug).then(({ data }) => {
                    this.form = data;
                    this.modelId = data.modelId;
                });
            },
            getVersions(id) {
                if (!this.isEdit) {
                    this.form.versionId = null;
                }

                this.$store.autoAdminApi.getVersions(id).then(({ data }) => {
                    this.versionsList = data.items;
                });
            },
            uploadPhoto() {
                this.isLoading = true;
                let formData = new FormData();
                formData.append("photo", this.file);
                const fileReader = new FileReader();
                let arr = [];
                fileReader.onload = () => {
                    arr.push(fileReader.result);
                    this.$store.autoAdminApi
                        .uploadImages({ file: arr })
                        .then(({ data }) => {
                            this.form.photoId = data.id[0];
                            this.isLoading = false;
                        })
                        .catch(() => {
                            this.isLoading = false;
                        });
                };
                fileReader.readAsDataURL(this.file);
            },
        },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <the-detail-wrapper
        :title="title"
        type-list="/offers"
        :current-status="statusPage"
        @handler-submit="send"
    >
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>

        <b-field label="Модель">
            <b-select placeholder="Выбрать модель" v-model="modelId">
                <option v-for="model in modelsList" :key="model.id" :value="model.id">
                    {{ model.name }}
                </option>
            </b-select>
        </b-field>
        <b-field v-show="modelId" label="Комплектация">
            <b-select placeholder="Выбрать комплектацию" v-model="form.versionId">
                <option v-for="version in versionsList" :key="version.id" :value="version.id">
                    {{ version.name }}
                </option>
            </b-select>
        </b-field>

        <b-field label="Цена">
            <b-input v-model.number="form.price"></b-input>
        </b-field>

        <b-field label="Пробег">
            <b-input v-model.number="form.mileage"></b-input>
        </b-field>

        <b-field label="Цвет кузова">
            <b-input v-model="form.color"></b-input>
        </b-field>

        <b-field label="Год выпуска">
            <b-input v-model="form.issuedAt"></b-input>
        </b-field>

        <b-field label="Статус">
            <b-select placeholder="Выбрать статус" v-model="form.status">
                <option value="in_stock">В наличии</option>
                <option value="ordered">В резерве</option>
                <option value="sold">Продано</option>
                <option value="eol">EOL</option>
            </b-select>
        </b-field>

        <b-field label="Изображение" message="Размеры превью 640x382">
            <b-field class="file" :class="{ 'has-name': !!file }">
                <b-upload v-model="file" class="file-label" @input="uploadPhoto">
                    <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">Загрузить фото</span>
                    </span>
                    <span class="file-name" v-if="file">
                        {{ file.name }}
                    </span>
                </b-upload>
            </b-field>
        </b-field>
        <div class="block">
            <img
                class="preview-img-single"
                v-if="form.photoId"
                :src="apiUrl('/gallery/image/' + form.photoId + '.orig')"
                alt=""
            />
        </div>
    </the-detail-wrapper>
</template>

<style lang="scss"></style>
